const FooterMenu = (): JSX.Element => {
  return (
    <footer
      className="bg-inherit bottom-0 left-0 right-0 mt-auto flex flex-col-reverse items-center justify-center px-[75px] pb-[20px] pr-[50px] pt-[20px]
   font-heebo text-[10px] md:flex-row h-sm:fixed h-sm:z-10 h-sm:justify-between"
    >
      <span className="font-normal text-white md:text-gray-600">© ORSNN, Inc.</span>
      <span className="text-center font-normal text-slate-200 md:text-right">
        Transforming secondary capital markets into an efficient digital experience
      </span>
    </footer>
  );
};

export default FooterMenu;
